const MATH_JAX_CONFIG = {
    tex: {
        inlineMath: [["$", "$"]],
        displayMath: [["$$", "$$"]]
    },
};
export default MATH_JAX_CONFIG;